// Grid cells render their own <TableCell>. To reuse them unchanged in a card
// each sits in a small table whose parts are display:block, which keeps the
// DOM valid and lets the slot's type settle on the cell through `inherit`.
export const cellSlotSx = {
    'display': 'block',
    'minWidth': 0,
    '& tbody, & tr': { display: 'block' },
    '& td': {
        display: 'block',
        border: 0,
        p: 0,
        bgcolor: 'transparent',
        font: 'inherit',
        color: 'inherit'
    },
    '& td .MuiTypography-root': { font: 'inherit', color: 'inherit' }
};

export const listSx = (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.sizes.mobileCardGap}px`
});

export const cardSx = (theme) => ({
    p: `${theme.sizes.mobileCardPadding}px`,
    borderRadius: `${theme.shape.card}px`,
    border: 1,
    borderColor: 'divider',
    boxShadow: theme.customShadows.card
});

export const clickableCardSx = { cursor: 'pointer' };

export const cardHeaderSx = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 1.25
};

export const identitySx = {
    flex: 1,
    fontWeight: 700,
    fontSize: 13,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};

export const secondaryRowSx = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
    mb: 1.5
};

export const secondaryLabelSx = {
    fontSize: 11,
    fontWeight: 600,
    color: 'text.secondary'
};

export const secondaryValueSx = {
    fontSize: 13.5,
    fontWeight: 600
};

export const cardFooterSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    borderTop: 1,
    borderColor: 'divider',
    pt: 1.25
};

export const headlineSx = {
    fontSize: 19,
    fontWeight: 800
};

export const metaSx = {
    fontSize: 12,
    fontWeight: 600,
    color: 'text.secondary',
    ml: 'auto'
};

export const listHeaderSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mx: 0.25,
    mb: 1.25
};

export const actionsButtonSx = (theme) => ({
    width: 36,
    height: 36,
    borderRadius: `${theme.shape.option}px`,
    bgcolor: 'background.neutral'
});

// "Load more · 20 of 134": a phone's pager. The list grows in place.
export const loadMoreButtonSx = (theme) => ({
    'height': theme.sizes.touchTarget,
    'fontSize': 14,
    'fontWeight': 800,
    'borderRadius': `${theme.shape.toolbarControl}px`,
    'borderWidth': 1.5,
    'bgcolor': 'background.paper',
    '&:hover': { borderWidth: 1.5 }
});
